import styled, { css } from 'styled-components';

import { SurveyDialogDetails } from '@r1-frontend/survey/context/selectors';

import { Anchor } from '@r1-frontend/ui-kit/atoms/anchor';
import { Button } from '@r1-frontend/ui-kit/atoms/button';
import { H4 } from '@r1-frontend/ui-kit/atoms/typography/heading';
import { Text } from '@r1-frontend/ui-kit/atoms/typography/text';
import { PopupBase } from '@r1-frontend/ui-kit/molecules/Popup/components/PopupBase';
import { PopupContent } from '@r1-frontend/ui-kit/molecules/Popup/components/PopupContent';
import { PopupHeader } from '@r1-frontend/ui-kit/molecules/Popup/components/PopupHeader';
import { ThemedProperties } from '@r1-frontend/ui-kit/themes/types';

const SurveyPopup = styled(({
    isOpen,
    image,
    title,
    description,
    buttonText,
    externalLink,
    onStart,
    onClose,
    ...props
}: Omit<SurveyDialogDetails, 'name' | 'type'> & {
    onClose: () => void,
    onStart: () => void,
}) => (
    <PopupBase isOpen={isOpen} onClose={onClose} $width={359} {...props}>
        <PopupHeader onClose={onClose}>
            <div aria-label='image-container'>
                <img src={image} alt='Логотип опроса'/>
            </div>
        </PopupHeader>
        <PopupContent>
            <div aria-label='main-content'>
                <div aria-label='text-content'>
                    <H4 dangerouslySetInnerHTML={{ __html: title }}/>
                    <Text $size={'lg'} $color={'hint'} dangerouslySetInnerHTML={{ __html: description }}/>
                </div>
                <Anchor href={externalLink} target='_blank' rel='noopener'>
                    <Button $type={'primary'} onClick={onStart}>{buttonText}</Button>
                </Anchor>
            </div>
        </PopupContent>
    </PopupBase>
))`
    ${({ theme }: ThemedProperties) => css`
        article[role="dialog"] {
            @media (min-width: ${theme.breakpoints.tablet}) {
                padding: ${theme.indents.m}px;
            }
        }

        ${PopupHeader} > div[aria-label="image-container"] {
            position: relative;
            left: 50%;
            transform: translateX(-50%);
            width: 162px;
            height: 162px;

            img {
                width: 100%;
                height: 100%;
                object-position: center;
                object-fit: contain;
            }
        }

        ${PopupContent} {
            margin-right: 0;
            padding-right: 0;

            div[aria-label="main-content"] {
                display: flex;
                flex-direction: column;
                gap: ${theme.indents.s}px;

                div[aria-label="text-content"] {
                    display: flex;
                    flex-direction: column;
                    gap: ${theme.indents.xxs}px;
                }

                ${Button} {
                    width: 100%;
                }
            }
        }
    `};
`;

SurveyPopup.displayName = 'SurveyDialog__desktop';

export { SurveyPopup };
